import { useEffect, useState, useMemo } from "react";
import { notify } from "../../common/Toast";
import {
  foundry,
  materialInward,
  rawMaterials,
  SpectroCom,
  inchargeAPI,
  Furnace,
} from "../../utlis/apiService";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import Model from "../../common/Model";
import EntityAddModal from "../../common/EntityAddModal";
import { motion } from "framer-motion";
import InputField from "../../common/InputField";
import { FaFlask, FaFire, FaBalanceScale, FaBoxes, FaClipboardList } from "react-icons/fa";
import { FormHeader } from "../../common/Shared";
import {
  FiDatabase,
  FiTruck,
  FiBox,
  FiClock,
  FiZap,
  FiCpu,
  FiActivity,
  FiBarChart2,
  FiMinus,
  FiPaperclip,
  FiFileText,
  FiEye,
} from "react-icons/fi";

dayjs.extend(duration);
dayjs.extend(utc);

const SectionTitle = ({ title, icon: Icon, className }) => {
  return (
    <div
      className={`flex items-center gap-2 mb-6 border-b border-slate-200 pb-2 ${className}`}
    >
      {Icon && <Icon className="text-primary text-xl" />}
      <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider">
        {title}
      </h3>
    </div>
  );
};

const fixedSelectComponents = [
  { label: "Mg", value: 1 },
  { label: "Si", value: 2 },
  { label: "Fe", value: 3 },
  { label: "Zn", value: 4 },
  { label: "Cu", value: 5 },
  { label: "Al", value: 6 },
  { label: "Au", value: 7 },
];

const FoundryForm = ({ onCancel, initialData, onSave, isEditing, isSaving }) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userId = user?.userId;
  const today = new Date().toISOString()?.split("T")[0];
  const [isRawMaterialData, setIsRawMaterialData] = useState([]);
  const [isSkuData, setIsSkuData] = useState([]);
  const [isSpectroData, setIsSpectroData] = useState([]);
  const [isInchargeData, setIsInchargeData] = useState([]);
  const [isFurnaceData, setIsFurnaceData] = useState([]);
  const [scrapInputs, setScrapInputs] = useState([
    { Inward_No: "", qty: "", casting_No: "" },
  ]);
  const [sampleSpectroInputs, setSampleSpectroInputs] = useState(
    fixedSelectComponents.map((c) => ({
      componentId: c.value,
      label: c.label,
      percentage: "",
      editable: false,
    })),
  );
  const [sampleSpectroFile, setSampleSpectroFile] = useState(null);

  const [finalSpectroInputs, setFinalSpectroInputs] = useState(
    fixedSelectComponents.map((c) => ({
      componentId: c.value,
      label: c.label,
      percentage: "",
      editable: false,
    })),
  );
  const [finalSpectroFile, setFinalSpectroFile] = useState(null);

  const [otherMetalEntries, setOtherMetalEntries] = useState([
    {
      CASTING_NO: "",
      INGOT: 0,
      PLANT_SCRAP: 0,
      PLANT_DISCARD: 0,
      DROSS_INGOT: 0,
      BEND_LOG: 0,
      HILL_METAL: 0,
      PIT_METAL: 0,
      TENDIS_METAL: 0,
      DROSS_METAL: 0,
      CREATED_BY: userId,
    },
  ]);
  const [foundryEntry, setFoundryEntry] = useState({
    CASTING_DATE: today,
    IN_CHARGE_ID: "",
    FURNACE_ID: "",
    LDO_PRE_HEATING_LEVEL: "",
    LDO_CHARGING_START_LEVEL: "",
    LDO_CHARGING_END_LEVEL: "",
    LDO_MAIN_TANK_OPENING_LEVEL: "",
    LDO_MAIN_TANK_CLOSING_LEVEL: "",
    LDO_PRE_HEATING_CONSUMPTION: 0,
    LDO_FURNACE_CONSUMPTION: 0,
    LDO_TOTAL_CONSUMPTION: "",
    LDO_DIESEL_OPENING_LEVEL: "",
    LDO_DIESEL_CLOSING_LEVEL: "",
    ALLOY_GRAD: "",
    HLINE_GRAD: "",
    NO_OF_LOGS: "",
    LOG_LENGTH: "",
    LOG_WEIGHT: "",
    TOTAL_OUTPUT_WEIGHT: "",
    REMARK: "",
    CREATED_BY: userId,
  });
  const [selectedFurnaceDetails, setSelectedFurnaceDetails] = useState(null);
  const [consumptionErrors, setConsumptionErrors] = useState({
    LDO_CHARGING_START_LEVEL: "",
    LDO_CHARGING_END_LEVEL: "",
  });
  const [scrapErrors, setScrapErrors] = useState({});
  const [furnaceMasterData, setFurnaceMasterData] = useState([]);
  const [furnaceEntries, setFurnaceEntries] = useState([
    {
      FURNACE_NO: 1,
      PRE_HEATED: false,
      PRE_HEATING_START_TIME: "",
      CHARGING_START_TIME: "",
      CHARGING_END_TIME: "",
      CASTING_START_TIME: "",
      CASTING_END_TIME: "",
      PRE_HEAT_TIME: "00:00:00",
      FURNACE_TIME: "00:00:00",
      CASTING_TIME: "00:00:00",
      TOTAL_TIME: "00:00:00",
      CREATED_BY: userId,
    },
  ]);
  const [byProductEntries, setByProductEntries] = useState([
    {
      DROSS: 0,
      ALUMINIUM_METAL_REUSABLE: 0,
      IRON: 0,
      DROSS_INGOT: 0,
      PIT_METAL: 0,
      HILL_METAL: 0,
      TENDIS_METAL: 0,
      BURNING_LOSS: 0,
      CREATED_BY: userId,
    },
  ]);
  const [chemicalEntries, setChemicalEntries] = useState([
    { MATERIAL_ID: "", qty: "", CREATED_BY: userId },
  ]);
  const [otherConsumableEntries, setOtherConsumableEntries] = useState([
    { MATERIAL_ID: "", qty: "", CREATED_BY: userId },
  ]);
  const [rawMaterialsResData, setRawMaterialsResData] = useState([]);
  const [isOtherConsumableData, setIsOtherConsumableData] = useState([]);
  const [scrapTotal, setScrapTotal] = useState(0);
  const [totalInputKg, setTotalInputKg] = useState(0);
  const [modalType, setModalType] = useState(null);
  const [logFactor, setLogFactor] = useState(0.034);
  const [isManualCalc, setIsManualCalc] = useState(false);
  const [hasSetInitialManual, setHasSetInitialManual] = useState(false);

  const yieldEfficiency = useMemo(() => {
    if (totalInputKg > 0 && foundryEntry.TOTAL_OUTPUT_WEIGHT > 0) {
      return ((Number(foundryEntry.TOTAL_OUTPUT_WEIGHT) / totalInputKg) * 100).toFixed(1);
    }
    return "0.0";
  }, [totalInputKg, foundryEntry.TOTAL_OUTPUT_WEIGHT]);

  const totalConsumableMetal = useMemo(() => {
    return chemicalEntries.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
  }, [chemicalEntries]);

  const totalOtherConsumables = useMemo(() => {
    return otherConsumableEntries.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
  }, [otherConsumableEntries]);

  const totalDieselConsumption = useMemo(() => {
    if (!foundryEntry.LDO_DIESEL_CLOSING_LEVEL) return "";
    const opening = parseFloat(foundryEntry.LDO_DIESEL_OPENING_LEVEL) || 0;
    const closing = parseFloat(foundryEntry.LDO_DIESEL_CLOSING_LEVEL) || 0;
    const diff = opening - closing;
    return diff > 0 ? diff.toFixed(2) : "0.00";
  }, [
    foundryEntry.LDO_DIESEL_OPENING_LEVEL,
    foundryEntry.LDO_DIESEL_CLOSING_LEVEL,
  ]);

  const totalByProducts = useMemo(() => {
    const bp = byProductEntries[0] || {};
    return (
      Number(bp.DROSS || 0) +
      Number(bp.ALUMINIUM_METAL_REUSABLE || 0) +
      Number(bp.IRON || 0) +
      Number(bp.DROSS_INGOT || 0) +
      Number(bp.PIT_METAL || 0) +
      Number(bp.HILL_METAL || 0) +
      Number(bp.TENDIS_METAL || 0)
    );
  }, [byProductEntries]);

  useEffect(() => {
    if (!initialData) {
      const now = dayjs().format("YYYY-MM-DDTHH:mm");
      setFurnaceEntries((prev) =>
        prev.map((entry) => ({
          ...entry,
          PRE_HEATING_START_TIME: now,
          CHARGING_START_TIME: now,
          CHARGING_END_TIME: now,
          CASTING_START_TIME: now,
          CASTING_END_TIME: now,
          PRE_HEAT_TIME: "00:00:00",
          FURNACE_TIME: "00:00:00",
          CASTING_TIME: "00:00:00",
          TOTAL_TIME: "00:00:00",
        })),
      );
    }
  }, []);

  const handleScrapChange = (index, field, value) => {
    const updated = [...scrapInputs];
    updated[index][field] = value;

    if (field === "Inward_No") {
      const selected = isSkuData.find((opt) => opt.value === Number(value));
      updated[index].skuDetail = selected?.detail || "";
      const stockPart = selected?.detail?.split(" - ")?.pop() || "0";
      updated[index].originalStock = parseFloat(stockPart) || 0;
    }

    if (field === "QUANTITY") {
      const used = parseFloat(value) || 0;
      const scrap = updated[index];
      const available = (scrap.originalStock || 0) + (isEditing ? scrap.baseQuantity || 0 : 0);
      const newErrors = { ...scrapErrors };
      if (scrap.Inward_No && used > available) {
        newErrors[index] = `Quantity exceeds available stock (${available.toFixed(2)})`;
      } else {
        delete newErrors[index];
      }
      setScrapErrors(newErrors);
    }

    setScrapInputs(updated);

    const newScrapTotal = updated.reduce(
      (sum, scrap) => sum + (parseFloat(scrap.QUANTITY) || 0),
      0,
    );
    setScrapTotal(newScrapTotal);
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const [skuRes, rawMaterialsRes, spectroRes, inchargeRes, furnaceRes] =
          await Promise.all([
            materialInward.getAllSKU(),
            rawMaterials.getAll(),
            SpectroCom.getAll(),
            inchargeAPI.getAll(),
            Furnace.getAll(),
          ]);

        setIsSkuData(
          skuRes.map((c) => ({
            value: c.inward_No,
            label: c.skU_No,
            detail: c.skU_Detail,
          })),
        );
        setRawMaterialsResData(rawMaterialsRes);
        setIsRawMaterialData(
          rawMaterialsRes
            .filter((c) => c.category_Id === 7)
            .map((c) => ({
              value: Number(c.id),
              label: c.name,
            })),
        );
        setIsOtherConsumableData(
          rawMaterialsRes
            .filter((c) => c.category_Id === 12)
            .map((c) => ({
              value: Number(c.id),
              label: c.name,
            })),
        );

        setIsSpectroData(
          spectroRes.map((c) => ({
            value: c.components_Id,
            label: c.components_Name,
          })),
        );

        setIsInchargeData(
          inchargeRes.data.map((c) => ({
            value: c.id,
            label: c.incharge_Name,
          })),
        );
        setFurnaceMasterData(furnaceRes?.data || []);
        setIsFurnaceData(
          furnaceRes?.data?.map((f) => ({
            value: f.furnaceId,
            label: f.furnaceName,
            billetWtMm: f.billetWtMm,
          })) || [],
        );
      } catch (error) {
        notify("Error fetching dropdown data", "error");
      }
    };
    fetchDropdownData();
  }, []);

  const handleAddScrapInput = () => {
    setScrapInputs([...scrapInputs, { Inward_No: "", qty: "" }]);
  };

  const handleAddChemicalInput = () => {
    setChemicalEntries([
      ...chemicalEntries,
      { MATERIAL_ID: "", qty: "", CREATED_BY: userId },
    ]);
  };

  const handleAddSampleSpectro = () => {
    setSampleSpectroInputs([
      ...sampleSpectroInputs,
      { componentId: "", percentage: "" },
    ]);
  };

  const handleAddFinalSpectro = () => {
    setFinalSpectroInputs([
      ...finalSpectroInputs,
      { componentId: "", percentage: "" },
    ]);
  };

  const handleRemoveScrapInput = async (indexToRemove) => {
    const item = scrapInputs[indexToRemove];
    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteScrap(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Scrap entry deleted", "success");
      } catch (err) {
        notify("Failed to delete scrap entry", "error");
        return;
      }
    }
    if (scrapInputs.length === 1) {
      setScrapInputs([{ Inward_No: "", qty: "", casting_No: "" }]);
    } else {
      setScrapInputs(scrapInputs.filter((_, idx) => idx !== indexToRemove));
    }
  };

  const handleAddOtherConsumableInput = () => {
    setOtherConsumableEntries([
      ...otherConsumableEntries,
      { MATERIAL_ID: "", qty: "", CREATED_BY: userId },
    ]);
  };

  const handleRemoveOtherConsumables = async (indexToRemove) => {
    const item = otherConsumableEntries[indexToRemove];

    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteChemical(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Other Consumable deleted", "success");
      } catch (err) {
        notify("Failed to delete other consumable", "error");
        return;
      }
    }

    if (otherConsumableEntries.length === 1) {
      setOtherConsumableEntries([{ MATERIAL_ID: "", qty: "", CREATED_BY: userId }]);
    } else {
      setOtherConsumableEntries(
        otherConsumableEntries.filter((_, idx) => idx !== indexToRemove),
      );
    }
  };

  const handleRemoveChemicals = async (indexToRemove) => {
    const item = chemicalEntries[indexToRemove];

    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteChemical(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Chemical entry deleted", "success");
      } catch (err) {
        notify("Failed to delete chemical entry", "error");
        return;
      }
    }

    if (chemicalEntries.length === 1) {
      setChemicalEntries([{ MATERIAL_ID: "", qty: "", CREATED_BY: userId }]);
    } else {
      setChemicalEntries(
        chemicalEntries.filter((_, idx) => idx !== indexToRemove),
      );
    }
  };

  const handleRemoveSampleSpectro = async (indexToRemove) => {
    const item = sampleSpectroInputs[indexToRemove];

    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteSampleSpectro(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Sample Spectro deleted", "success");
      } catch (err) {
        notify("Failed to delete Sample Spectro", "error");
        return;
      }
    }

    if (sampleSpectroInputs.length === 1) {
      setSampleSpectroInputs([{ componentId: "", percentage: "" }]);
    } else {
      setSampleSpectroInputs(
        sampleSpectroInputs.filter((_, idx) => idx !== indexToRemove),
      );
    }
  };

  const handleRemoveFinalSpectro = async (indexToRemove) => {
    const item = finalSpectroInputs[indexToRemove];

    if (isEditing && item.SEQ_NO) {
      try {
        await foundry.deleteFinalSpectro(foundryEntry.CASTING_NO, item.SEQ_NO);
        notify("Final Spectro deleted", "success");
      } catch (err) {
        notify("Failed to delete Final Spectro", "error");
        return;
      }
    }

    if (finalSpectroInputs.length === 1) {
      setFinalSpectroInputs([{ componentId: "", percentage: "" }]);
    } else {
      setFinalSpectroInputs(
        finalSpectroInputs.filter((_, idx) => idx !== indexToRemove),
      );
    }
  };

  const handleFurnaceChange = (index, field, value) => {
    const updated = [...furnaceEntries];
    updated[index][field] = value;

    // clear error on change
    if (updated[index][`error_${field}`]) {
      delete updated[index][`error_${field}`];
    }

    const parseTime = (timeStr) => {
      if (!timeStr) return null;
      let d;
      if (typeof timeStr === "string" && (timeStr.includes("T") || timeStr.includes("-"))) {
        d = dayjs(timeStr);
      } else {
        d = dayjs(`2000-01-01T${timeStr}`);
      }
      return d.isValid() ? dayjs(`2000-01-01T${d.format("HH:mm:ss")}`) : null;
    };

    const formatDur = (start, end, forceZero = false) => {
      if (!start || !end || !start.isValid() || !end.isValid()) return "00:00:00";
      let diff = end.diff(start);
      if (diff < 0) diff += 24 * 60 * 60 * 1000;
      if (forceZero && diff < 0) return "00:00:00";

      const dur = dayjs.duration(diff);
      const hours = Math.floor(dur.asHours());
      const mins = dur.minutes();
      const secs = dur.seconds();
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    };

    const entry = updated[index];
    const preHeatingStart = parseTime(entry.PRE_HEATING_START_TIME);
    const chargingStart = parseTime(entry.CHARGING_START_TIME);
    const chargingEnd = parseTime(entry.CHARGING_END_TIME);
    const castingStart = parseTime(entry.CASTING_START_TIME);
    const castingEnd = parseTime(entry.CASTING_END_TIME);

    entry.PRE_HEAT_TIME = formatDur(preHeatingStart, chargingStart);
    entry.FURNACE_TIME = formatDur(chargingStart, chargingEnd);
    entry.CASTING_TIME = formatDur(castingStart, castingEnd);
    entry.TOTAL_TIME = formatDur(chargingStart, castingEnd);

    const getTimeVal = (timeStr) => {
      if (!timeStr) return null;
      if (typeof timeStr === "string" && (timeStr.includes("T") || timeStr.includes("-"))) {
        return dayjs(timeStr).format("HH:mm:ss");
      }
      return timeStr;
    };

    setFurnaceEntries(updated);
  };

  const totalOtherMetalsKg = otherMetalEntries.reduce((sum, item) => {
    return (
      sum +
      Number(item.INGOT || 0) +
      Number(item.PLANT_SCRAP || 0) +
      Number(item.PLANT_DISCARD || 0) +
      Number(item.DROSS_INGOT || 0) +
      Number(item.BEND_LOG || 0) +
      Number(item.HILL_METAL || 0) +
      Number(item.PIT_METAL || 0) +
      Number(item.TENDIS_METAL || 0) +
      Number(item.DROSS_METAL || 0)
    );
  }, 0);

  const handleOtherMetalChange = (index, field, value) => {
    const updated = [...otherMetalEntries];
    updated[index][field] = value;

    const calcWeight = (item) =>
      Number(item.INGOT || 0) +
      Number(item.PLANT_SCRAP || 0) +
      Number(item.PLANT_DISCARD || 0) +
      Number(item.DROSS_INGOT || 0) +
      Number(item.BEND_LOG || 0) +
      Number(item.HILL_METAL || 0) +
      Number(item.PIT_METAL || 0) +
      Number(item.TENDIS_METAL || 0) +
      Number(item.DROSS_METAL || 0);

    updated[index].TOTAL_WEIGHT = calcWeight(updated[index]);

    setOtherMetalEntries(updated);

    const allMetalsSum = updated.reduce(
      (sum, item) => sum + (item.TOTAL_WEIGHT || 0),
      0,
    );
    setTotalInputKg(scrapTotal + allMetalsSum);
  };

  useEffect(() => {
    const metalsSum = otherMetalEntries.reduce((sum, item) => {
      return (
        sum +
        Number(item.INGOT || 0) +
        Number(item.PLANT_SCRAP || 0) +
        Number(item.PLANT_DISCARD || 0) +
        Number(item.DROSS_INGOT || 0) +
        Number(item.BEND_LOG || 0) +
        Number(item.HILL_METAL || 0) +
        Number(item.PIT_METAL || 0) +
        Number(item.TENDIS_METAL || 0) +
        Number(item.DROSS_METAL || 0)
      );
    }, 0);

    setTotalInputKg(scrapTotal + metalsSum);
  }, [scrapTotal, otherMetalEntries]);

  useEffect(() => {
    if (initialData) {
      setFoundryEntry(initialData.foundryEntry || {});
      const anyMissing = (initialData.scrapEntries || []).some(s => s.Inward_No && !s.skuDetail);
      if (anyMissing && isSkuData.length > 0) {
        const updatedScrap = (initialData.scrapEntries || []).map((scrap) => {
          const skuInfo = isSkuData.find((skuInfo) => Number(skuInfo.value) === Number(scrap.Inward_No));
          if (skuInfo) {
            const stockPart = skuInfo.detail?.split(" - ")?.pop() || "0";
            return {
              ...scrap,
              skuDetail: skuInfo.detail,
              originalStock: parseFloat(stockPart) || 0,
              baseQuantity: parseFloat(scrap.QUANTITY) || 0,
            };
          }
          return scrap;
        });
        setScrapInputs(updatedScrap);
      } else {
        setScrapInputs(initialData.scrapEntries || []);
      }
      setScrapTotal(initialData.scrapTotal || 0);
      setOtherMetalEntries(initialData.otherMetalEntries || []);
      const entries = (initialData.furnaceEntries || []).map(entry => {
        const parseTime = (timeStr) => {
          if (!timeStr) return null;
          let d;
          if (typeof timeStr === "string" && (timeStr.includes("T") || timeStr.includes("-"))) {
            d = dayjs(timeStr);
          } else {
            d = dayjs(`2000-01-01T${timeStr}`);
          }
          return d.isValid() ? dayjs(`2000-01-01T${d.format("HH:mm:ss")}`) : null;
        };

        const formatDur = (start, end) => {
          if (!start || !end || !start.isValid() || !end.isValid()) return "00:00:00";
          let diff = end.diff(start);
          if (diff < 0) diff += 24 * 60 * 60 * 1000;
          const dur = dayjs.duration(diff);
          const hours = Math.floor(dur.asHours());
          const mins = dur.minutes();
          const secs = dur.seconds();
          return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
        };

        const preHeatingStart = parseTime(entry.PRE_HEATING_START_TIME);
        const chargingStart = parseTime(entry.CHARGING_START_TIME);
        const chargingEnd = parseTime(entry.CHARGING_END_TIME);
        const castingStart = parseTime(entry.CASTING_START_TIME);
        const castingEnd = parseTime(entry.CASTING_END_TIME);

        return {
          ...entry,
          PRE_HEAT_TIME: formatDur(preHeatingStart, chargingStart),
          FURNACE_TIME: formatDur(chargingStart, chargingEnd),
          CASTING_TIME: formatDur(castingStart, castingEnd),
          TOTAL_TIME: formatDur(chargingStart, castingEnd)
        };
      });
      setFurnaceEntries(entries);
      setByProductEntries(initialData.byProductEntries || []);
      setFinalSpectroInputs(initialData.finalSpectroEntries || []);
      setSampleSpectroInputs(initialData.sampleSpectroEntries || []);

      if (initialData.foundryEntry?.furnacE_ID) {
        setFoundryEntry((prev) => ({
          ...prev,
          FURNACE_ID: initialData.foundryEntry.furnacE_ID,
        }));
      }
    }
  }, [initialData, isSkuData]);

  // Handle chemical splitting when materials are loaded
  useEffect(() => {
    if (initialData && rawMaterialsResData.length > 0) {
      const allChemicals = initialData.chemicalEntries || [];
      const chemMetals = allChemicals.filter((item) => {
        const mat = rawMaterialsResData.find(
          (rm) => rm.id === item.MATERIAL_ID,
        );
        return mat?.category_Id === 7;
      });
      const otherConsums = allChemicals.filter((item) => {
        const mat = rawMaterialsResData.find(
          (rm) => rm.id === item.MATERIAL_ID,
        );
        return mat?.category_Id === 12;
      });

      setChemicalEntries(chemMetals.length > 0 ? chemMetals : [{ MATERIAL_ID: "", qty: "", CREATED_BY: userId }]);
      setOtherConsumableEntries(otherConsums.length > 0 ? otherConsums : [{ MATERIAL_ID: "", qty: "", CREATED_BY: userId }]);
    }
  }, [initialData, rawMaterialsResData]);

  useEffect(() => {
    if (foundryEntry.FURNACE_ID) {
      const furnace = furnaceMasterData.find(
        (f) => f.furnaceId === Number(foundryEntry.FURNACE_ID),
      );
      setSelectedFurnaceDetails(furnace);
      if (furnace?.billetWtMm) {
        setLogFactor(Number(furnace.billetWtMm));
      } else {
        setLogFactor(0.034); // Default fallback
      }
    } else {
      setSelectedFurnaceDetails(null);
      setLogFactor(0.034);
    }
  }, [foundryEntry.FURNACE_ID, furnaceMasterData]);

  useEffect(() => {
    if (isManualCalc) return;

    const logLength = Number(foundryEntry.LOG_LENGTH || 0);
    const logCount = Number(foundryEntry.NO_OF_LOGS || 0);
    const singleWeight = logLength * logFactor;
    const totalWeight = singleWeight * logCount;

    setFoundryEntry((prev) => ({
      ...prev,
      LOG_WEIGHT: singleWeight > 0 ? parseFloat(singleWeight.toFixed(2)) : "",
      TOTAL_OUTPUT_WEIGHT: totalWeight > 0 ? parseFloat(totalWeight.toFixed(2)) : "",
    }));
  }, [foundryEntry.LOG_LENGTH, foundryEntry.NO_OF_LOGS, logFactor, isManualCalc]);

  useEffect(() => {
    if (initialData && initialData.foundryEntry && !hasSetInitialManual && logFactor > 0) {
      const entry = initialData.foundryEntry;
      const logLength = Number(entry.LOG_LENGTH || 0);
      const logCount = Number(entry.NO_OF_LOGS || 0);
      
      const expectedSingle = parseFloat((logLength * logFactor).toFixed(2));
      const expectedTotal = parseFloat((expectedSingle * logCount).toFixed(2));
      
      const actualSingle = Number(entry.LOG_WEIGHT || 0);
      const actualTotal = Number(entry.TOTAL_OUTPUT_WEIGHT || 0);
      
      if (
        (actualSingle > 0 && Math.abs(actualSingle - expectedSingle) > 0.02) ||
        (actualTotal > 0 && Math.abs(actualTotal - expectedTotal) > 0.02)
      ) {
        setIsManualCalc(true);
      }
      setHasSetInitialManual(true);
    }
  }, [initialData, logFactor, hasSetInitialManual]);

  useEffect(() => {
    const preHeatingLevel = Number(foundryEntry.LDO_PRE_HEATING_LEVEL || 0);
    const chargingStartLevel = Number(
      foundryEntry.LDO_CHARGING_START_LEVEL || 0,
    );
    const chargingEndLevel = Number(foundryEntry.LDO_CHARGING_END_LEVEL || 0);

    const preHeatingConsumption =
      foundryEntry.LDO_CHARGING_START_LEVEL && foundryEntry.LDO_PRE_HEATING_LEVEL
        ? Math.max(0, chargingStartLevel - preHeatingLevel)
        : 0;

    const furnaceConsumption =
      foundryEntry.LDO_CHARGING_END_LEVEL &&
        foundryEntry.LDO_CHARGING_START_LEVEL
        ? Math.max(0, chargingEndLevel - chargingStartLevel)
        : 0;

    const totalConsumption = preHeatingConsumption + furnaceConsumption;

    setFoundryEntry((prev) => ({
      ...prev,
      LDO_PRE_HEATING_CONSUMPTION: parseFloat(preHeatingConsumption.toFixed(2)),
      LDO_FURNACE_CONSUMPTION: parseFloat(furnaceConsumption.toFixed(2)),
      LDO_TOTAL_CONSUMPTION: parseFloat(totalConsumption.toFixed(2)),
    }));
  }, [
    foundryEntry.LDO_CHARGING_START_LEVEL,
    foundryEntry.LDO_CHARGING_END_LEVEL,
  ]);

  useEffect(() => {
    const totalScrap = scrapTotal + (totalOtherMetalsKg || 0);
    const byproduct = byProductEntries[0] || {};

    const burningLoss =
      totalScrap -
      Number(byproduct.DROSS || 0) -
      Number(byproduct.ALUMINIUM_METAL_REUSABLE || 0) -
      Number(byproduct.IRON || 0) -
      Number(byproduct.DROSS_INGOT || 0) -
      Number(byproduct.PIT_METAL || 0) -
      Number(byproduct.HILL_METAL || 0) -
      Number(byproduct.TENDIS_METAL || 0) -
      Number(foundryEntry.TOTAL_OUTPUT_WEIGHT || 0);

    setByProductEntries(prev => {
      if (!prev[0]) return prev;
      const updated = [...prev];
      const newBurningLoss = parseFloat(burningLoss.toFixed(2));
      if (updated[0].BURNING_LOSS !== newBurningLoss) {
        updated[0] = { ...updated[0], BURNING_LOSS: newBurningLoss };
        return updated;
      }
      return prev;
    });
  }, [
    scrapTotal,
    totalOtherMetalsKg,
    byProductEntries[0]?.DROSS,
    byProductEntries[0]?.ALUMINIUM_METAL_REUSABLE,
    byProductEntries[0]?.IRON,
    byProductEntries[0]?.DROSS_INGOT,
    byProductEntries[0]?.PIT_METAL,
    byProductEntries[0]?.HILL_METAL,
    byProductEntries[0]?.TENDIS_METAL,
    foundryEntry.TOTAL_OUTPUT_WEIGHT
  ]);



  const handleSubmit = (e) => {
    e.preventDefault();

    // -- Time Validation --
    const getTimeVal = (timeStr) => {
      if (!timeStr) return null;
      if (typeof timeStr === "string" && (timeStr.includes("T") || timeStr.includes("-"))) {
        return dayjs(timeStr).format("HH:mm:ss");
      }
      return timeStr;
    };

    const fEntry = furnaceEntries[0];
    if (fEntry) {
      let hasTimeError = false;
      const updatedFurnace = [...furnaceEntries];

      const cStart = getTimeVal(fEntry.CHARGING_START_TIME);
      const cEnd = getTimeVal(fEntry.CHARGING_END_TIME);
      if (cStart && cEnd && cStart >= cEnd) {
        updatedFurnace[0].error_CHARGING_END_TIME = "Must be greater than Charging Start Time";
        hasTimeError = true;
      } else {
        delete updatedFurnace[0].error_CHARGING_END_TIME;
      }

      const castStart = getTimeVal(fEntry.CASTING_START_TIME);
      const castEnd = getTimeVal(fEntry.CASTING_END_TIME);
      if (castStart && castEnd && castStart >= castEnd) {
        updatedFurnace[0].error_CASTING_END_TIME = "Must be greater than Casting Start Time";
        hasTimeError = true;
      } else {
        delete updatedFurnace[0].error_CASTING_END_TIME;
      }

      if (hasTimeError) {
        setFurnaceEntries(updatedFurnace);
        setActiveTab(0);
        return;
      }
    }

    // -- Level/Reading Sequence Validation --
    const phLevel = Number(foundryEntry.LDO_PRE_HEATING_LEVEL || 0);
    const csLevel = Number(foundryEntry.LDO_CHARGING_START_LEVEL || 0);
    const ceLevel = Number(foundryEntry.LDO_CHARGING_END_LEVEL || 0);

    const fuelLabel =
      ["GAS", "ELECTRICAL"].includes(
        selectedFurnaceDetails?.fuelSource?.toUpperCase(),
      )
        ? "Reading"
        : "Level";

    if (foundryEntry.LDO_CHARGING_START_LEVEL && furnaceEntries[0]?.PRE_HEATED && csLevel <= phLevel) {
      setConsumptionErrors((prev) => ({
        ...prev,
        LDO_CHARGING_START_LEVEL: `must be greater than Pre Heating ${fuelLabel}`,
      }));
      return;
    }

    if (foundryEntry.LDO_CHARGING_END_LEVEL && ceLevel <= csLevel) {
      setConsumptionErrors((prev) => ({
        ...prev,
        LDO_CHARGING_END_LEVEL: `must be greater than Charging Start ${fuelLabel}`,
      }));
      return;
    }

    // -- Scrap Stock Validation (Warning Only) --
    const newScrapErrors = { ...scrapErrors };
    scrapInputs.forEach((scrap, index) => {
      const used = parseFloat(scrap.QUANTITY) || 0;
      const available =
        (scrap.originalStock || 0) + (isEditing ? scrap.baseQuantity || 0 : 0);
      if (scrap.Inward_No && used > available) {
        newScrapErrors[index] = `Quantity exceeds available stock (${available.toFixed(2)})`;
      }
    });
    setScrapErrors(newScrapErrors);

    const formatPayloadTime = (timeStr) => {
      if (!timeStr || timeStr === "" || timeStr === "00:00:00") return null;
      // If it's already a full ISO string, just ensure correct format
      if (typeof timeStr === "string" && (timeStr.includes("T") || timeStr.includes("-"))) {
        return dayjs(timeStr).format("YYYY-MM-DDTHH:mm:ss");
      }
      // If it's HH:mm or HH:mm:ss, combine with CASTING_DATE
      const combined = dayjs(`${foundryEntry.CASTING_DATE}T${timeStr}`);
      return combined.isValid() ? combined.format("YYYY-MM-DDTHH:mm:ss") : null;
    };

    const payload = {
      foundryEntry: {
        ...foundryEntry,
        CASTING_DATE: dayjs(foundryEntry.CASTING_DATE).format("YYYY-MM-DDTHH:mm:ss"),
        IN_CHARGE_ID: Number(foundryEntry.IN_CHARGE_ID),
        FURNACE_ID: Number(foundryEntry.FURNACE_ID),
        LDO_PRE_HEATING_LEVEL: Number(foundryEntry.LDO_PRE_HEATING_LEVEL),
        LDO_CHARGING_START_LEVEL: Number(foundryEntry.LDO_CHARGING_START_LEVEL),
        LDO_CHARGING_END_LEVEL: Number(foundryEntry.LDO_CHARGING_END_LEVEL),
        LDO_MAIN_TANK_OPENING_LEVEL: Number(
          foundryEntry.LDO_MAIN_TANK_OPENING_LEVEL,
        ),
        LDO_MAIN_TANK_CLOSING_LEVEL: Number(
          foundryEntry.LDO_MAIN_TANK_CLOSING_LEVEL,
        ),
        LDO_PRE_HEATING_CONSUMPTION: Number(
          foundryEntry.LDO_PRE_HEATING_CONSUMPTION,
        ),
        LDO_FURNACE_CONSUMPTION: Number(foundryEntry.LDO_FURNACE_CONSUMPTION),
        LDO_TOTAL_CONSUMPTION: Number(foundryEntry.LDO_TOTAL_CONSUMPTION),
        LDO_DIESEL_OPENING_LEVEL: Number(foundryEntry.LDO_DIESEL_OPENING_LEVEL),
        LDO_DIESEL_CLOSING_LEVEL: Number(foundryEntry.LDO_DIESEL_CLOSING_LEVEL),
        NO_OF_LOGS: Number(foundryEntry.NO_OF_LOGS),
        LOG_LENGTH: Number(foundryEntry.LOG_LENGTH),
        LOG_WEIGHT: Number(foundryEntry.LOG_WEIGHT),
        TOTAL_OUTPUT_WEIGHT: Number(foundryEntry.TOTAL_OUTPUT_WEIGHT),
        CREATED_BY: userId,
      },
      scrapEntries: scrapInputs.map((item, index) => ({
        SEQ_NO: index + 1,
        CASTING_NO: isEditing ? initialData?.CASTING_NO || "" : "",
        INWARD_NO: Number(item.Inward_No),
        QUANTITY: Number(item.QUANTITY),
        CREATED_BY: userId,
      })),
      otherMetalEntries: otherMetalEntries.map((item) => ({
        ...item,
        INGOT: Number(item.INGOT),
        PLANT_SCRAP: Number(item.PLANT_SCRAP),
        PLANT_DISCARD: Number(item.PLANT_DISCARD),
        DROSS_INGOT: Number(item.DROSS_INGOT),
        BEND_LOG: Number(item.BEND_LOG),
        HILL_METAL: Number(item.HILL_METAL),
        PIT_METAL: Number(item.PIT_METAL),
        TENDIS_METAL: Number(item.TENDIS_METAL),
        DROSS_METAL: Number(item.DROSS_METAL),
        TOTAL_WEIGHT: Number(totalOtherMetalsKg),
        CREATED_BY: userId,
      })),
      furnaceEntries: furnaceEntries.map((item) => ({
        FURNACE_NO: Number(item.FURNACE_NO),
        PRE_HEATED: Boolean(item.PRE_HEATED),
        PRE_HEATING_START_TIME: item.PRE_HEATED ? formatPayloadTime(item.PRE_HEATING_START_TIME) : null,
        CHARGING_START_TIME: formatPayloadTime(item.CHARGING_START_TIME),
        CHARGING_END_TIME: formatPayloadTime(item.CHARGING_END_TIME),
        CASTING_START_TIME: formatPayloadTime(item.CASTING_START_TIME),
        CASTING_END_TIME: formatPayloadTime(item.CASTING_END_TIME),
        TOTAL_TIME: item.TOTAL_TIME,
        CREATED_BY: userId,
      })),
      byProductEntries: byProductEntries.map((item) => ({
        ...item,
        DROSS: Number(item.DROSS),
        ALUMINIUM_METAL_REUSABLE: Number(item.ALUMINIUM_METAL_REUSABLE),
        IRON: Number(item.IRON),
        DROSS_INGOT: Number(item.DROSS_INGOT),
        PIT_METAL: Number(item.PIT_METAL),
        HILL_METAL: Number(item.HILL_METAL),
        TENDIS_METAL: Number(item.TENDIS_METAL),
        BURNING_LOSS: Number(item.BURNING_LOSS),
        CREATED_BY: userId,
      })),
      chemicalEntries: [...chemicalEntries, ...otherConsumableEntries]
        .filter(item => item.MATERIAL_ID)
        .map((item, index) => ({
          SEQ_NO: index + 1,
          MATERIAL_ID: Number(item.MATERIAL_ID),
          QUANTITY: Number(item.qty),
          CREATED_BY: userId,
        })),
      finalSpectroEntries: finalSpectroInputs.map((item, index) => ({
        Seq_No: index + 1,
        Components_Id: Number(item.componentId),
        Components_Value: Number(item.percentage),
        CREATED_BY: userId,
      })),
      sampleSpectroEntries: sampleSpectroInputs.map((item, index) => ({
        Seq_No: index + 1,
        Components_Id: Number(item.componentId),
        Components_Value: Number(item.percentage),
        CREATED_BY: userId,
      })),
    };

    onSave(payload, isEditing ? initialData?.CASTING_NO : "", {
      sampleSpectroFile,
      finalSpectroFile,
    });
  };

  const handleViewFile = (type) => {
    const castingNo = foundryEntry.CASTING_NO;
    if (!castingNo) return;

    let path = "";
    if (type === "sample") {
      path = `https://hline.blob.core.windows.net/hlinefiles/Extrusion/SpectroReport/SampleReport/${castingNo}.pdf`;
    } else {
      path = `https://hline.blob.core.windows.net/hlinefiles/Extrusion/SpectroReport/FinalReport/${castingNo}.pdf`;
    }
    window.open(path, "_blank");
  };

  const optionMap = {
    rawMaterial: {
      setter: setIsRawMaterialData,
      field: "id",
    },
    sampleSpectroComponent: {
      setter: setIsSpectroData,
      field: "components_Id",
    },
    finalSpectroComponent: {
      setter: setIsSpectroData,
      field: "components_Id",
    },
  };

  const handleEntityAddSuccess = async (type) => {
    const { setter } = optionMap[type];

    try {
      let updatedData;

      switch (type) {
        case "rawMaterial":
          updatedData = await rawMaterials.getAll();
          setter(
            updatedData
              .filter((c) => c.category_Id === 7)
              .map((c) => ({
                value: c.id,
                label: c.name,
              })),
          );
          updatedData = await rawMaterials.getAll();
          setIsOtherConsumableData(
            updatedData
              .filter((c) => c.category_Id === 12)
              .map((c) => ({
                value: c.id,
                label: c.name,
              })),
          );
          break;
        case "sampleSpectroComponent":
          updatedData = await SpectroCom.getAll();
          setter(
            updatedData.map((s) => ({
              value: s.components_Id,
              label: s.components_Name,
            })),
          );
          break;
        case "finalSpectroComponent":
          updatedData = await SpectroCom.getAll();
          setter(
            updatedData.map((s) => ({
              value: s.components_Id,
              label: s.components_Name,
            })),
          );
          break;
        default:
          return;
      }

      setModalType(null);
    } catch (err) {
      notify("Failed to refresh dropdown", "error");
    }
  };

  const tabs = [
    { label: "Furnace Time", icon: FiClock },
    { label: "Scrap & Plant Scrap", icon: FiDatabase },
    { label: "Fuel Table", icon: FiTruck },
    { label: "Consumable Metal", icon: FiZap },
    { label: "By-Products", icon: FiCpu },
    { label: "Log Output", icon: FiActivity },
    { label: "Spectro Analysis", icon: FiBarChart2 },
  ];

  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="flex flex-col h-screen bg-white font-plus overflow-hidden">
      <FormHeader
        title={isEditing ? "Edit Foundry Log" : "New Foundry Log"}
        onCancel={onCancel}
      />

      <div className="flex flex-col lg:flex-row flex-1 overflow-hidden">
        {/* Sidebar Navigation */}
        <div className="w-full lg:w-96 bg-slate-50 border-r border-slate-200 overflow-y-auto custom-scrollbar p-3">
          <div className="space-y-1">
            {tabs.map((tab, idx) => (
              <>
                <button
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  className={`w-full flex items-center gap-3 px-4 py-2 rounded-xl text-sm font-bold transition-all duration-300 group relative overflow-hidden ${activeTab === idx
                    ? "bg-primary text-white  "
                    : "text-slate-600 hover:bg-white hover:text-primary hover:"
                    }`}
                >
                  <tab.icon
                    className={`text-lg transition-transform duration-300 ${activeTab === idx ? "scale-110" : "group-hover:scale-110"}`}
                  />
                  <span className="relative z-10">{tab.label}</span>
                  {activeTab === idx && (
                    <motion.div
                      layoutId="activeTabGlow"
                      className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent pointer-events-none"
                    />
                  )}
                </button>
              </>
            ))}
          </div>

          {/* Quick Info Box - Standardized White Style */}
          <div className="mt-4 p-4 bg-white border border-slate-200 rounded-none text-slate-800">
            <h4 className="text-[9px] font-black uppercase tracking-[0.2em] text-slate-400 mb-3 border-b border-slate-100 pb-2">
              System Summary
            </h4>
            <div className="space-y-1.5">
              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiDatabase className="text-sky-500 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">Scrap Total</span>
                </div>
                <span className="text-xs font-black text-slate-800">
                  {scrapTotal.toFixed(1)} <span className="text-[8px] text-slate-400">KG</span>
                </span>
              </div>
              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiDatabase className="text-orange-500 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">Plant Scrap</span>
                </div>
                <span className="text-xs font-black text-slate-800">
                  {totalOtherMetalsKg.toFixed(1)} <span className="text-[8px] text-slate-400">KG</span>
                </span>
              </div>

              {/* Consumable Totals */}
              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiZap className="text-yellow-500 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">Cons. Metal</span>
                </div>
                <span className="text-xs font-black text-slate-800">
                  {totalConsumableMetal.toFixed(1)} <span className="text-[8px] text-slate-400">KG</span>
                </span>
              </div>

              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiZap className="text-orange-400 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">Other Cons.</span>
                </div>
                <span className="text-xs font-black text-slate-800">
                  {totalOtherConsumables.toFixed(1)} <span className="text-[8px] text-slate-400">KG</span>
                </span>
              </div>

              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiCpu className="text-purple-500 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">By Products</span>
                </div>
                <span className="text-xs font-black text-slate-800">
                  {totalByProducts.toFixed(1)} <span className="text-[8px] text-slate-400">KG</span>
                </span>
              </div>

              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiActivity className="text-rose-500 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">Burning Loss</span>
                </div>
                <span className="text-xs font-black text-slate-800">
                  {Number(byProductEntries[0]?.BURNING_LOSS || 0).toFixed(2)} <span className="text-[8px] text-slate-400">KG</span>
                </span>
              </div>

              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiActivity className="text-sky-400 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">Min Log Wt</span>
                </div>
                <span className="text-xs font-black text-slate-800">
                  {foundryEntry.LOG_WEIGHT || 0} <span className="text-[8px] text-slate-400">KG</span>
                </span>
              </div>

              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiActivity className="text-emerald-600 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">Output Wt</span>
                </div>
                <span className="text-xs font-black text-emerald-600">
                  {foundryEntry.TOTAL_OUTPUT_WEIGHT || 0} <span className="text-[8px] text-slate-400">KG</span>
                </span>
              </div>

              <div className="flex justify-between items-center bg-slate-50 p-2 border border-slate-100">
                <div className="flex items-center gap-2">
                  <FiActivity className="text-emerald-500 text-[12px]" />
                  <span className="text-[10px] font-bold text-slate-500 uppercase tracking-tight">No.Of Logs</span>
                </div>
                <span className="text-xs font-black text-slate-800">
                  {foundryEntry.NO_OF_LOGS || 0} ({foundryEntry.LOG_LENGTH || 0} mm) <span className="text-[8px] text-slate-400">Count</span>
                </span>
              </div>

              <div className="bg-white/5 p-3 rounded-2xl border border-white/10 space-y-2">
                <div className="flex justify-between items-center pb-2 border-b border-white/5">
                  <div className="flex items-center gap-2">
                    <FiActivity className="text-yellow-400 text-base" />
                    <span className="text-[11px] font-black uppercase tracking-wider text-slate-400">Grade</span>
                  </div>
                  <span className="text-base font-black text-yellow-400">
                    {foundryEntry.HLINE_GRAD || "N/A"}
                  </span>
                </div>

                <div className="grid grid-cols-1 gap-1.5 pt-1">
                  {["Au", "Mg", "Si", "Zn", "Fe"].map((compName) => {
                    const input = finalSpectroInputs.find(
                      (item) => {
                        const spectroComp = isSpectroData.find(s => s.value === item.componentId);
                        return (spectroComp?.label === compName) || (item.label === compName);
                      }
                    );
                    if (!input && !foundryEntry.HLINE_GRAD) return null;
                    return (
                      <div key={compName} className="flex justify-between items-center px-2 py-1 rounded-lg bg-black/20">
                        <span className="text-[10px] font-black text-slate-500 uppercase tracking-tighter">{compName}</span>
                        <span className="text-xs font-bold font-mono text-slate-200">
                          {input?.percentage || "0.0000"}
                        </span>
                      </div>
                    );
                  })}
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="flex-1 overflow-hidden flex flex-col bg-white">
          <div className="px-8 py-4 bg-white border-b border-slate-100 grid grid-cols-4 gap-4 items-center">
            <InputField
              type="date"
              value={foundryEntry.CASTING_DATE}
              onChange={(e) =>
                setFoundryEntry({
                  ...foundryEntry,
                  CASTING_DATE: e.target.value,
                })
              }
              label="Date"
            />

            <InputField value={foundryEntry.CASTING_NO || "0"} label="Casting No" disabled />

            <InputField
              type="select"
              label="Person In-Charge"
              placeholder="Select Person"
              value={foundryEntry.IN_CHARGE_ID}
              onChange={(val) =>
                setFoundryEntry({ ...foundryEntry, IN_CHARGE_ID: val })
              }
              options={isInchargeData}
              required
            />
            <InputField
              type="select"
              label="Furnace"
              placeholder="Select Furnace"
              value={foundryEntry.FURNACE_ID}
              onChange={(val) =>
                setFoundryEntry({ ...foundryEntry, FURNACE_ID: val })
              }
              options={isFurnaceData}
              required
            />
          </div>

          <form
            onSubmit={handleSubmit}
            className="flex-1 overflow-y-auto p-5 custom-scrollbar bg-slate-50/30"
          >
            <div className="max-w-full mx-auto">
              <div className="space-y-8">
                {activeTab === 0 && (
                  <div className="space-y-6">
                    <SectionTitle
                      title="Furnace Cycle Logistics"
                      icon={FiClock}
                    />
                    <div className="space-y-6">
                      {furnaceEntries.map((entry, index) => (
                        <div
                          key={index}
                          className="p-6 border border-slate-100 relative overflow-hidden group"
                        >
                          <div className="absolute top-0 left-0 w-2 h-full bg-primary" />

                          <div className="flex flex-wrap items-center justify-between mb-8 gap-4">
                            <div className="flex items-center gap-4">
                              <div className="flex items-center justify-center text-primary">
                                {entry.FURNACE_NO}
                              </div>
                            </div>
                            <label className="flex items-center gap-3 px-6 py-3 bg-slate-50 border border-slate-100 rounded-2xl cursor-pointer hover:bg-white hover:border-primary transition-all ">
                              <input
                                type="checkbox"
                                className="w-5 h-5 accent-primary rounded-lg"
                                checked={entry.PRE_HEATED || false}
                                onChange={(e) =>
                                  handleFurnaceChange(
                                    index,
                                    "PRE_HEATED",
                                    e.target.checked,
                                  )
                                }
                              />
                              <span className="text-xs font-black uppercase text-slate-600">
                                Furnace Pre-heated?
                              </span>
                            </label>
                          </div>

                          <div className={`grid grid-cols-1 md:grid-cols-3 ${entry.PRE_HEATED ? "lg:grid-cols-5" : "lg:grid-cols-4"} gap-2`}>
                            {[
                              ...(entry.PRE_HEATED
                                ? [
                                  {
                                    label: "Pre-Heating Start",
                                    key: "PRE_HEATING_START_TIME",
                                  },
                                ]
                                : []),
                              {
                                label: "Fur- Charging Start",
                                key: "CHARGING_START_TIME",
                              },
                              {
                                label: "Fur- Charging End",
                                key: "CHARGING_END_TIME",
                              },
                              {
                                label: "Casting Start",
                                key: "CASTING_START_TIME",
                              },
                              {
                                label: "Casting End",
                                key: "CASTING_END_TIME",
                              },
                            ].map((t) => (
                              <InputField
                                key={t.key}
                                label={t.label}
                                type="time"
                                value={entry[t.key]}
                                onChange={(val) =>
                                  handleFurnaceChange(index, t.key, val)
                                }
                                error={entry[`error_${t.key}`]}
                              />
                            ))}
                          </div>

                          <div className={`mt-6 grid grid-cols-1 ${entry.PRE_HEATED ? "md:grid-cols-4" : "md:grid-cols-3"} gap-6`}>
                            {entry.PRE_HEATED && (
                              <InputField
                                label="Pre-Heat Time"
                                value={entry.PRE_HEAT_TIME || "00:00:00"}
                                disabled
                              />
                            )}
                            <InputField
                              label="Furnace Time"
                              value={entry.FURNACE_TIME || "00:00:00"}
                              disabled
                            />
                            <InputField
                              label="Casting Time"
                              value={entry.CASTING_TIME || "00:00:00"}
                              disabled
                            />
                            <InputField
                              label="Total Time to Produce"
                              value={entry.TOTAL_TIME || "00:00:00"}
                              disabled
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {activeTab === 2 && (
                  <div className="space-y-6">
                    <SectionTitle
                      title={`${selectedFurnaceDetails?.fuelSource?.toUpperCase() || "LDO"} Consumption Monitoring`}
                      icon={FiTruck}
                    />
                    <div className="bg-white p-8 rounded-[2.5rem] border border-slate-100  relative overflow-hidden">
                      <div className="absolute top-0 right-0 w-48 h-48 bg-orange-50 rounded-full -mr-24 -mt-24 blur-2xl opacity-50" />

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10">
                        {[
                          {
                            label: "Pre Heating Level",
                            key: "LDO_PRE_HEATING_LEVEL",
                            unit: "Inches",
                          },
                          {
                            label: "Charging Start Level",
                            key: "LDO_CHARGING_START_LEVEL",
                            unit: "Inches",
                          },
                          {
                            label: "Charging End Level",
                            key: "LDO_CHARGING_END_LEVEL",
                            unit: "Inches",
                          },
                          {
                            label: "Main Tank Opening",
                            key: "LDO_MAIN_TANK_OPENING_LEVEL",
                            unit: "Inches",
                          },
                          {
                            label: "Main Tank Closing",
                            key: "LDO_MAIN_TANK_CLOSING_LEVEL",
                            unit: "Inches",
                          },
                        ]
                          .filter((f) => {
                            if (f.key === "LDO_PRE_HEATING_LEVEL") {
                              return furnaceEntries[0]?.PRE_HEATED;
                            }
                            if (
                              ["LDO_MAIN_TANK_OPENING_LEVEL", "LDO_MAIN_TANK_CLOSING_LEVEL"].includes(f.key)
                            ) {
                              return selectedFurnaceDetails?.fuelSource?.toUpperCase() === "OIL";
                            }
                            return true;
                          })
                          .map((f) => {
                            let label = f.label;
                            let unit = f.unit;
                            if (
                              ["GAS", "ELECTRICAL"].includes(
                                selectedFurnaceDetails?.fuelSource?.toUpperCase(),
                              )
                            ) {
                              label = label.replace("Level", "Reading");
                              unit = "Units";
                            }
                            return { ...f, label, unit };
                          })
                          .map((field) => (
                            <InputField
                              key={field.key}
                              label={field.label}
                              unit={field.unit}
                              value={foundryEntry[field.key]}
                              onChange={(val) =>
                                setFoundryEntry({
                                  ...foundryEntry,
                                  [field.key]: val,
                                })
                              }
                              onBlur={() => {
                                const ph = Number(
                                  foundryEntry.LDO_PRE_HEATING_LEVEL || 0,
                                );
                                const cs = Number(
                                  foundryEntry.LDO_CHARGING_START_LEVEL || 0,
                                );
                                const ce = Number(
                                  foundryEntry.LDO_CHARGING_END_LEVEL || 0,
                                );

                                const fuelLabel =
                                  ["GAS", "ELECTRICAL"].includes(
                                    selectedFurnaceDetails?.fuelSource?.toUpperCase(),
                                  )
                                    ? "Reading"
                                    : "Level";

                                let newErrors = { ...consumptionErrors };

                                // if (
                                //   field.key === "LDO_CHARGING_START_LEVEL"
                                // ) {
                                //   newErrors.LDO_CHARGING_START_LEVEL =
                                //     foundryEntry.LDO_CHARGING_START_LEVEL &&
                                //       furnaceEntries[0]?.PRE_HEATED &&
                                //       cs <= ph
                                //       ? `must be Less than Pre Heating ${fuelLabel}`
                                //       : "";
                                // }

                                // if (field.key === "LDO_CHARGING_END_LEVEL") {
                                //   newErrors.LDO_CHARGING_END_LEVEL =
                                //     foundryEntry.LDO_CHARGING_END_LEVEL &&
                                //       ce >= cs
                                //       ? `must be less than Charging Start ${fuelLabel}`
                                //       : "";
                                // }

                                setConsumptionErrors(newErrors);
                              }}
                              error={consumptionErrors[field.key]}
                            />
                          ))}

                        <div className="md:col-span-3">
                          <div className={`grid grid-cols-1 ${furnaceEntries[0]?.PRE_HEATED ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-4`}>
                            {furnaceEntries[0]?.PRE_HEATED && (
                              <InputField
                                label="Pre-Heating Consumption"
                                value={foundryEntry.LDO_PRE_HEATING_CONSUMPTION || 0}
                                unit={["GAS", "ELECTRICAL"].includes(selectedFurnaceDetails?.fuelSource?.toUpperCase()) ? "Units" : "Liters"}
                                disabled
                              />
                            )}

                            <InputField
                              label="Furnace Consumption"
                              value={foundryEntry.LDO_FURNACE_CONSUMPTION || 0}
                              unit={["GAS", "ELECTRICAL"].includes(selectedFurnaceDetails?.fuelSource?.toUpperCase()) ? "Units" : "Liters"}
                              disabled
                            />

                            <InputField
                              label="Total Consumption"
                              value={foundryEntry.LDO_TOTAL_CONSUMPTION || 0}
                              unit={["GAS", "ELECTRICAL"].includes(selectedFurnaceDetails?.fuelSource?.toUpperCase()) ? "Units" : "Liters"}
                              disabled
                            />
                          </div>
                        </div>

                        {/* Diesel Reading Section */}
                        <div className="md:col-span-3">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div className="space-y-2">
                              <label className="text-xs font-black text-slate-500 uppercase tracking-wider ml-1">Opening Reading</label>
                              <InputField
                                unit="Liter"
                                value={foundryEntry.LDO_DIESEL_OPENING_LEVEL}
                                onChange={(val) =>
                                  setFoundryEntry((prev) => ({
                                    ...prev,
                                    LDO_DIESEL_OPENING_LEVEL: val,
                                  }))
                                }
                                placeholder="0.00"
                                className="w-full"
                              />
                            </div>

                            <div className="space-y-2">
                              <label className="text-xs font-black text-slate-500 uppercase tracking-wider ml-1">Closing Reading</label>
                              <InputField
                                unit="Liter"
                                value={foundryEntry.LDO_DIESEL_CLOSING_LEVEL}
                                onChange={(val) =>
                                  setFoundryEntry((prev) => ({
                                    ...prev,
                                    LDO_DIESEL_CLOSING_LEVEL: val,
                                  }))
                                }
                                error={
                                  foundryEntry.LDO_DIESEL_CLOSING_LEVEL &&
                                    foundryEntry.LDO_DIESEL_OPENING_LEVEL &&
                                    parseFloat(foundryEntry.LDO_DIESEL_CLOSING_LEVEL) >=
                                    parseFloat(foundryEntry.LDO_DIESEL_OPENING_LEVEL)
                                    ? "must be less than opening value"
                                    : ""
                                }
                                placeholder="0.00"
                                className="w-full"
                              />
                            </div>
                          </div>

                          <div className="mt-6">
                            <InputField
                              label="Total Diesel Consumption"
                              value={totalDieselConsumption || "0"}
                              unit="Liter"
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === 1 && (
                  <div className="space-y-4">
                    <SectionTitle
                      title="Scrap & Plant Scrap"
                      icon={FiDatabase}
                    />
                    <div className="space-y-2">
                      <h4 className="text-xs font-black uppercase tracking-widest text-slate-400 mb-4">Scrap Inputs</h4>
                      {scrapInputs.map((scrap, index) => (
                        <div
                          key={index}
                          className="relative transition-all group"
                        >
                          <div className="flex justify-end">
                            {scrapInputs.length > 1 && (
                              <button
                                type="button"
                                onClick={() => handleRemoveScrapInput(index)}
                                className="text-[10px] font-bold uppercase tracking-widest text-red-500 hover:text-red-700 flex items-center gap-1"
                              >
                                <FiMinus size={12} /> Remove
                              </button>
                            )}
                          </div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative z-10">
                            <InputField
                              type="select"
                              label={`SKU for Scrap ${index + 1}`}
                              value={scrap.Inward_No}
                              onChange={(val) => {
                                handleScrapChange(index, "Inward_No", val);
                              }}
                              options={isSkuData}
                              required
                            />
                            <InputField
                              label="Quantity Used"
                              type="text"
                              value={scrap.QUANTITY}
                              onChange={(val) =>
                                handleScrapChange(index, "QUANTITY", val)
                              }
                              onBlur={() => {
                                const used = parseFloat(scrap.QUANTITY) || 0;
                                const available =
                                  (scrap.originalStock || 0) +
                                  (isEditing ? scrap.baseQuantity || 0 : 0);
                                if (scrap.Inward_No && used > available) {
                                  setScrapErrors((prev) => ({
                                    ...prev,
                                    [index]: `Quantity cannot exceed available stock (${available.toFixed(2)})`,
                                  }));
                                } else {
                                  setScrapErrors((prev) => {
                                    const newErrors = { ...prev };
                                    delete newErrors[index];
                                    return newErrors;
                                  });
                                }
                              }}
                              error={scrapErrors[index]}
                              unit="Kg"
                              placeholder="0.00"
                              required
                            />
                          </div>
                          <div className="mt-4 flex justify-between items-center relative z-10">
                            {scrap.skuDetail ? (
                              <div className="flex items-center gap-2 px-4 py-2.5 bg-slate-50 text-slate-600 rounded-xl text-sm font-bold border border-slate-100 ">
                                <FiFileText className="text-primary" />
                                {(() => {
                                  const parts = scrap.skuDetail.split(" - ");
                                  const currentStockStr = parts[parts.length - 1];
                                  const currentStock = parseFloat(currentStockStr) || 0;
                                  const baseQty = isEditing ? scrap.baseQuantity || 0 : 0;
                                  const totalAllowed = currentStock + baseQty;
                                  const used = parseFloat(scrap.QUANTITY) || 0;
                                  const closing = totalAllowed - used;
                                  const namePart = parts
                                    .slice(0, parts.length - 1)
                                    .join(" - ");
                                  return `${namePart} - Closing Stock : ${closing.toFixed(2)} = (${totalAllowed.toFixed(2)} - ${used.toFixed(2)})`;
                                })()}
                              </div>
                            ) : (
                              <div />
                            )}
                          </div>
                        </div>
                      ))}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <button
                          type="button"
                          onClick={handleAddScrapInput}
                          className="w-full py-4 bg-slate-50 text-slate-500 rounded-none text-xs font-black uppercase tracking-widest hover:bg-slate-100 transition-all duration-300"
                        >
                          + Add Another Scrap Item
                        </button>
                        <div className="">
                          <InputField
                            label="Total Load (Scrap + Plant Scrap)"
                            value={totalInputKg.toFixed(2)}
                            unit="Kg"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                    <div className="bg-white mb-6">
                      <h4 className="text-xs font-black uppercase tracking-widest text-slate-400 mb-4">PLANT SCRAP</h4>
                      {otherMetalEntries.map((item, index) => (
                        <div
                          key={index}
                          className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-6"
                        >
                          {[
                            { label: "Plant Scrap", key: "PLANT_SCRAP" },
                            {
                              label: "Plant Discard",
                              key: "PLANT_DISCARD",
                            },
                            { label: "Dross Ingot", key: "DROSS_INGOT" },
                            { label: "Bend Log", key: "BEND_LOG" },
                            { label: "Hill Metal", key: "HILL_METAL" },
                            { label: "Pit Metal", key: "PIT_METAL" },
                            { label: "Tendis Metal", key: "TENDIS_METAL" },
                            { label: "Dross Metal", key: "DROSS_METAL" },
                          ].map((f) => (
                            <InputField
                              key={f.key}
                              label={f.label}
                              unit="Kg"
                              value={item[f.key]}
                              onChange={(val) =>
                                handleOtherMetalChange(index, f.key, val)
                              }
                            />
                          ))}
                        </div>
                      ))}
                    </div>


                  </div>
                )}

                {activeTab === 3 && (
                  <div className="space-y-6">
                    <SectionTitle
                      title="Consumable Metal"
                      icon={FiZap}
                    />
                    <div className="space-y-4">
                      {chemicalEntries.map((item, index) => (
                        <motion.div
                          key={index}
                          className="bg-white p-8 rounded-[2.5rem] border border-slate-100  relative group overflow-hidden"
                        >
                          <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button
                              type="button"
                              onClick={() => handleRemoveChemicals(index)}
                              className="w-8 h-8 bg-red-50 text-red-500 rounded-full flex items-center justify-center hover:bg-red-500 hover:text-white transition-all "
                            >
                              <FiMinus />
                            </button>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-start">
                            <InputField
                              type="selectWithAdd"
                              label="Consumable Metal"
                              value={item.MATERIAL_ID}
                              onChange={(selected) => {
                                const selectedMaterial =
                                  rawMaterialsResData.find(
                                    (rm) => rm.id === selected?.value,
                                  );
                                const updated = [...chemicalEntries];
                                updated[index].MATERIAL_ID =
                                  selected?.value;
                                const originalStock = selectedMaterial?.totalQuantity || 0;
                                const used = Number(updated[index].qty || 0);
                                updated[index].stock = originalStock;
                                updated[index].closingStock = originalStock - used;
                                if (used > originalStock) {
                                  updated[index].error = `Quantity exceeds available stock (${originalStock.toFixed(2)})`;
                                } else {
                                  delete updated[index].error;
                                }
                                setChemicalEntries(updated);
                              }}
                              options={isRawMaterialData}
                              onAddNewClick={() =>
                                setModalType("rawMaterial")
                              }
                              placeholder="Select Metal"
                            />
                            <InputField
                              label="Quantity Used"
                              type="text"
                              value={item.qty}
                              onChange={(val) => {
                                const updated = [...chemicalEntries];
                                updated[index].qty = val;
                                const selectedMaterial =
                                  rawMaterialsResData.find(
                                    (rm) =>
                                      rm.id ===
                                      Number(updated[index].MATERIAL_ID),
                                  );
                                const originalStock =
                                  selectedMaterial?.totalQuantity || 0;
                                const used = Number(val || 0);
                                updated[index].stock = originalStock;
                                updated[index].closingStock = originalStock - used;
                                if (used > originalStock) {
                                  updated[index].error = `Quantity exceeds available stock (${originalStock.toFixed(2)})`;
                                } else {
                                  delete updated[index].error;
                                }
                                setChemicalEntries(updated);
                              }}
                              error={item.error}
                              unit="Kg"
                            />
                            <div className="flex flex-col">
                              <InputField
                                label="Available Stock"
                                value={item.stock || "0"}
                                unit="Kg"
                                disabled
                              />
                              {item.closingStock !== undefined && (
                                <span className="text-[10px] text-emerald-600 font-bold mt-1 ml-auto">
                                  Closing Stock: {item.closingStock.toFixed(2)} Kg
                                </span>
                              )}
                            </div>
                            <button
                              type="button"
                              onClick={handleAddChemicalInput}
                              className="w-full mt-4 py-4 bg-slate-50 text-slate-500 rounded-none text-xs font-black uppercase tracking-widest hover:bg-slate-100 transition-all duration-300"
                            >
                              + Add Metal
                            </button>
                          </div>

                        </motion.div>
                      ))}

                    </div>

                    {/* Other Consumables Part */}
                    <div className="">
                      <SectionTitle
                        title="  Other Consumables"
                        icon={FiZap}
                      />
                      <div className="space-y-4">
                        {otherConsumableEntries.map((item, index) => (
                          <motion.div
                            key={index}
                            className="bg-white p-8 rounded-[2.5rem] border border-slate-100  relative group overflow-hidden"
                          >
                            <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity">
                              <button
                                type="button"
                                onClick={() => handleRemoveOtherConsumables(index)}
                                className="w-8 h-8 bg-red-50 text-red-500 rounded-full flex items-center justify-center hover:bg-red-500 hover:text-white transition-all "
                              >
                                <FiMinus />
                              </button>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-start">
                              <InputField
                                type="selectWithAdd"
                                label="Other Consumable"
                                value={item.MATERIAL_ID}
                                onChange={(selected) => {
                                  const selectedMaterial =
                                    rawMaterialsResData.find(
                                      (rm) => rm.id === selected?.value,
                                    );
                                  const updated = [...otherConsumableEntries];
                                  updated[index].MATERIAL_ID =
                                    selected?.value;
                                  const originalStock = selectedMaterial?.totalQuantity || 0;
                                  const used = Number(updated[index].qty || 0);
                                  updated[index].stock = originalStock;
                                  updated[index].closingStock = originalStock - used;
                                  if (used > originalStock) {
                                    updated[index].error = `Quantity exceeds available stock (${originalStock.toFixed(2)})`;
                                  } else {
                                    delete updated[index].error;
                                  }
                                  setOtherConsumableEntries(updated);
                                }}
                                options={isOtherConsumableData}
                                onAddNewClick={() =>
                                  setModalType("rawMaterial")
                                }
                                placeholder="Select Consumable"
                              />
                              <InputField
                                label="Quantity Used"
                                type="text"
                                value={item.qty}
                                onChange={(val) => {
                                  const updated = [...otherConsumableEntries];
                                  updated[index].qty = val;
                                  const selectedMaterial =
                                    rawMaterialsResData.find(
                                      (rm) =>
                                        rm.id ===
                                        Number(updated[index].MATERIAL_ID),
                                    );
                                  const originalStock =
                                    selectedMaterial?.totalQuantity || 0;
                                  const used = Number(val || 0);
                                  updated[index].stock = originalStock;
                                  updated[index].closingStock = originalStock - used;
                                  if (used > originalStock) {
                                    updated[index].error = `Quantity exceeds available stock (${originalStock.toFixed(2)})`;
                                  } else {
                                    delete updated[index].error;
                                  }
                                  setOtherConsumableEntries(updated);
                                }}
                                error={item.error}
                                unit="Kg"
                              />
                              <div className="flex flex-col">
                                <InputField
                                  label="Available Stock"
                                  value={item.stock || "0"}
                                  unit="Kg"
                                  disabled
                                />
                                {item.closingStock !== undefined && (
                                  <span className="text-[10px] text-emerald-600 font-bold mt-1 ml-auto">
                                    Closing Stock: {item.closingStock.toFixed(2)} Kg
                                  </span>
                                )}
                              </div>
                              <button
                                type="button"
                                onClick={handleAddOtherConsumableInput}
                                className="w-full mt-4 py-4 bg-slate-50 text-slate-500 rounded-none text-xs font-black uppercase tracking-widest hover:bg-slate-100 transition-all duration-300"
                              >
                                + Add Consumable
                              </button>
                            </div>
                          </motion.div>
                        ))}

                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 4 && (
                  <div className="space-y-6">
                    <div className="flex justify-between items-center mb-6 border-b border-slate-200 pb-2">
                      <SectionTitle
                        title="By-Product Recovery"
                        icon={FiCpu}
                        className="mb-0 border-none pb-0"
                      />
                      <div className="flex items-center gap-3 px-4 py-1.5 bg-slate-50 rounded-xl border border-slate-200 ">
                        <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">Total Scrap</span>
                        <span className="text-sm font-bold text-slate-700">
                          {(scrapTotal + totalOtherMetalsKg).toFixed(1)} <span className="text-xs font-medium opacity-50">Kg</span>
                        </span>
                      </div>
                    </div>
                    <div className="bg-white p-10 rounded-[2.5rem] border border-slate-100  relative overflow-hidden">
                      <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-50 rounded-full blur-3xl opacity-30 -mr-32 -mt-16" />

                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative z-10">
                        {[
                          {
                            label: "Dross",
                            key: "DROSS",
                            icon: FaBalanceScale,
                          },
                          {
                            label: "Aluminum Metal (Reusable)",
                            key: "ALUMINIUM_METAL_REUSABLE",
                            icon: FaBoxes,
                          },
                          {
                            label: "Iron",
                            key: "IRON",
                            icon: FiBox,
                          },
                          {
                            label: "Dross Ingot",
                            key: "DROSS_INGOT",
                            icon: FaBalanceScale,
                          },
                          {
                            label: "Pit Metal",
                            key: "PIT_METAL",
                            icon: FiBox,
                          },
                          {
                            label: "Hill Metal",
                            key: "HILL_METAL",
                            icon: FiBox,
                          },
                          {
                            label: "Tendis Metal",
                            key: "TENDIS_METAL",
                            icon: FiBox,
                          },
                          {
                            label: "Burning Loss",
                            key: "BURNING_LOSS",
                            icon: FaFire,
                          },
                        ].map((f) => (
                          <div key={f.key} className="flex flex-col gap-1">
                            <InputField
                              label={f.label}
                              unit="Kg"
                              value={byProductEntries[0][f.key]}
                              readOnly={f.key === "BURNING_LOSS"}
                              onChange={(val) =>
                                setByProductEntries((prev) => {
                                  const updated = [...prev];
                                  updated[0][f.key] = val;
                                  return updated;
                                })
                              }
                            />
                            {f.key === "BURNING_LOSS" && (
                              <div className="text-[10px] text-slate-500 font-bold px-2 py-1.5 bg-slate-50 border border-slate-100 rounded-md mt-1">
                                {(() => {
                                  const totalScrap = scrapTotal + (totalOtherMetalsKg || 0);
                                  const byproduct = byProductEntries[0] || {};
                                  const byProdSum = Number(byproduct.DROSS || 0) + Number(byproduct.ALUMINIUM_METAL_REUSABLE || 0) + Number(byproduct.IRON || 0) + Number(byproduct.DROSS_INGOT || 0) + Number(byproduct.PIT_METAL || 0) + Number(byproduct.HILL_METAL || 0) + Number(byproduct.TENDIS_METAL || 0);
                                  const outWt = Number(foundryEntry.TOTAL_OUTPUT_WEIGHT || 0);
                                  return `Formula: ${totalScrap.toFixed(2)} (Load) - ${byProdSum.toFixed(2)} (By-Prod) - ${outWt.toFixed(2)} (Output)`;
                                })()}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === 5 && (
                  <div className="space-y-6">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <SectionTitle
                        title="Log Production Output"
                        icon={FiActivity}
                      />
                      <div className="flex items-center gap-2 self-start sm:self-center">
                        <span className="text-xs font-bold uppercase text-slate-500 mr-1">Calculation Mode:</span>
                        <div className="flex items-center gap-1 bg-slate-100 p-1 rounded-xl border border-slate-200">
                          <button
                            type="button"
                            onClick={() => {
                              setIsManualCalc(false);
                              const logLength = Number(foundryEntry.LOG_LENGTH || 0);
                              const logCount = Number(foundryEntry.NO_OF_LOGS || 0);
                              const singleWeight = logLength * logFactor;
                              const totalWeight = singleWeight * logCount;

                              setFoundryEntry((prev) => ({
                                ...prev,
                                LOG_WEIGHT: singleWeight > 0 ? parseFloat(singleWeight.toFixed(2)) : "",
                                TOTAL_OUTPUT_WEIGHT: totalWeight > 0 ? parseFloat(totalWeight.toFixed(2)) : "",
                              }));
                            }}
                            className={`px-4 py-1.5 rounded-lg text-xs font-black uppercase tracking-wider transition-all duration-200 ${
                              !isManualCalc
                                ? "bg-primary text-white shadow-sm"
                                : "text-slate-600 hover:text-slate-800 hover:bg-slate-200"
                            }`}
                          >
                            Auto
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setIsManualCalc(true);
                            }}
                            className={`px-4 py-1.5 rounded-lg text-xs font-black uppercase tracking-wider transition-all duration-200 ${
                              isManualCalc
                                ? "bg-primary text-white shadow-sm"
                                : "text-slate-600 hover:text-slate-800 hover:bg-slate-200"
                            }`}
                          >
                            Manual
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
                      <div className="space-y-6 lg:col-span-2">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <InputField
                            label="No of Logs Output"
                            unit="Pieces"
                            value={foundryEntry.NO_OF_LOGS}
                            onChange={(val) =>
                              setFoundryEntry((prev) => ({
                                ...prev,
                                NO_OF_LOGS: val,
                              }))
                            }
                          />
                          <InputField
                            label="Length of Log"
                            unit="mm"
                            value={foundryEntry.LOG_LENGTH}
                            onChange={(val) =>
                              setByProductEntries((prev) => {
                                setFoundryEntry((p) => ({
                                  ...p,
                                  LOG_LENGTH: val,
                                }));
                                return prev;
                              })
                            }
                          />
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                          <InputField
                            label={isManualCalc ? "One Log Weight" : `One Log Weight (L*${logFactor})`}
                            value={foundryEntry.LOG_WEIGHT}
                            onChange={(val) => {
                              if (isManualCalc) {
                                setFoundryEntry((prev) => ({
                                  ...prev,
                                  LOG_WEIGHT: val,
                                }));
                              }
                            }}
                            unit="Kg"
                            disabled={!isManualCalc}
                          />
                          <InputField
                            label={isManualCalc ? "Total Output Wt" : `Total Output Wt (Formula L*N*${logFactor})`}
                            value={foundryEntry.TOTAL_OUTPUT_WEIGHT}
                            onChange={(val) => {
                              if (isManualCalc) {
                                setFoundryEntry((prev) => ({
                                  ...prev,
                                  TOTAL_OUTPUT_WEIGHT: val,
                                }));
                              }
                            }}
                            unit="Kg"
                            disabled={!isManualCalc}
                          />
                        </div>
                      </div>

                      <div className="space-y-6">
                        <InputField
                          label="Yield Efficiency"
                          value={yieldEfficiency}
                          unit="%"
                          disabled
                        />
                        <p className="text-[10px] text-slate-500 italic mt-2">
                          * Calculated based on standard L*N*{logFactor} manufacturing formula for extrusion log processing.
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === 6 && (
                  <div className="space-y-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <InputField
                        label="Alloy Grade"
                        type="text"
                        placeholder="Enter Alloy Grade"
                        value={foundryEntry.ALLOY_GRAD}
                        onChange={(val) =>
                          setFoundryEntry((prev) => ({
                            ...prev,
                            ALLOY_GRAD: val,
                          }))
                        }
                        required
                      />
                      <InputField
                        label="Grade"
                        type="text"
                        placeholder="Enter Grade"
                        value={foundryEntry.HLINE_GRAD}
                        onChange={(val) =>
                          setFoundryEntry((prev) => ({
                            ...prev,
                            HLINE_GRAD: val,
                          }))
                        }
                        required
                      />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                      <div className="bg-white">
                        <div className="flex items-center gap-3 mb-6">
                          <div className="w-10 h-10 rounded-xl bg-violet-50 flex items-center justify-center text-violet-600 border border-violet-100 uppercase text-[10px] font-black tracking-widest">
                            <FaFlask />
                          </div>
                          <h4 className="text-sm font-black text-slate-800 uppercase tracking-widest flex-1">
                            Sample Spectro Report Component (%)
                          </h4>
                          <div className="flex flex-col gap-2 items-end">
                            {isEditing && (
                              <button
                                type="button"
                                onClick={() => handleViewFile("sample")}
                                className="flex items-center justify-center gap-2 px-4 py-2 bg-primary text-white rounded-none text-[10px] font-black uppercase tracking-widest transition-all hover:bg-primary/90 min-w-[100px]"
                                title="View Current Report"
                              >
                                <FiEye size={12} />
                                View
                              </button>
                            )}

                            <div className="flex items-center gap-2">
                              <label className={`cursor-pointer flex items-center justify-center gap-2 px-4 py-2 rounded-none text-[10px] font-black uppercase tracking-widest transition-all border border-slate-300 min-w-[100px] hover:border-primary hover:text-primary ${sampleSpectroFile ? 'text-primary border-primary' : 'text-slate-500'}`}>
                                <FiPaperclip size={12} />
                                <span>
                                  {sampleSpectroFile ? "Change" : "Attach"}
                                </span>
                                <input
                                  type="file"
                                  className="hidden"
                                  onChange={(e) => setSampleSpectroFile(e.target.files[0])}
                                />
                              </label>

                              {sampleSpectroFile && (
                                <button
                                  type="button"
                                  onClick={() => setSampleSpectroFile(null)}
                                  className="w-8 h-8 flex items-center justify-center bg-red-50 text-red-500 rounded-none hover:bg-red-500 hover:text-white transition-all border border-red-100"
                                >
                                  <FiMinus size={14} />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>

                        {sampleSpectroFile && (
                          <div className="mt-[-1rem] mb-6 mx-2 p-3 bg-green-50/50 border border-green-100 rounded-2xl flex items-center gap-3">
                            <div className="w-8 h-8 rounded-xl bg-green-100 flex items-center justify-center text-green-600">
                              <FiFileText size={16} />
                            </div>
                            <div className="flex-1 overflow-hidden">
                              <p className="text-[10px] font-bold text-green-700 uppercase tracking-widest opacity-60">Ready to Upload</p>
                              <p className="text-xs font-black text-green-800 truncate">{sampleSpectroFile.name}</p>
                            </div>
                          </div>
                        )}

                        <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                          {sampleSpectroInputs.map((item, index) => (
                            <div
                              key={index}
                              className="group relative transition-all mb-4"
                            >
                              <button
                                type="button"
                                onClick={() =>
                                  handleRemoveSampleSpectro(index)
                                }
                                className="absolute top-8 -right-2 w-7 h-7 bg-red-50 text-red-500 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10"
                              >
                                <FiMinus />
                              </button>
                              <div className="grid grid-cols-2 gap-4">
                                <InputField
                                  type="selectWithAdd"
                                  label="Component"
                                  value={item.componentId}
                                  onChange={(selected) => {
                                    const updated = [
                                      ...sampleSpectroInputs,
                                    ];
                                    updated[index].componentId =
                                      selected?.value;
                                    setSampleSpectroInputs(updated);
                                  }}
                                  options={isSpectroData}
                                  onAddNewClick={() =>
                                    setModalType("sampleSpectroComponent")
                                  }
                                  placeholder="Select Component"
                                />
                                <InputField
                                  label="Value"
                                  type="text"
                                  value={item.percentage}
                                  onChange={(val) => {
                                    const updated = [
                                      ...sampleSpectroInputs,
                                    ];
                                    updated[index].percentage = val;
                                    setSampleSpectroInputs(updated);
                                  }}
                                  unit="%"
                                />
                              </div>
                            </div>
                          ))}
                        </div>

                        <button
                          type="button"
                          onClick={handleAddSampleSpectro}
                          className="w-full mt-6 py-4 bg-slate-50 text-slate-500 rounded-none text-xs font-black uppercase tracking-widest hover:bg-slate-100 transition-all duration-300"
                        >
                          + Add Sample Component
                        </button>
                      </div>

                      <div className="bg-white">
                        <div className="flex items-center gap-3 mb-6">
                          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary border border-primary/20 uppercase text-[10px] font-black tracking-widest">
                            <FaClipboardList />
                          </div>
                          <h4 className="text-sm font-black text-slate-800 uppercase tracking-widest flex-1">
                            Final Spectro Report Component (%)
                          </h4>
                          <div className="flex flex-col gap-2 items-end">
                            {isEditing && (
                              <button
                                type="button"
                                onClick={() => handleViewFile("final")}
                                className="flex items-center justify-center gap-2 px-4 py-2 bg-primary text-white rounded-none text-[10px] font-black uppercase tracking-widest transition-all hover:bg-primary/90 min-w-[100px]"
                                title="View Current Report"
                              >
                                <FiEye size={12} />
                                View
                              </button>
                            )}

                            <div className="flex items-center gap-2">
                              <label className={`cursor-pointer flex items-center justify-center gap-2 px-4 py-2 rounded-none text-[10px] font-black uppercase tracking-widest transition-all border border-slate-300 min-w-[100px] hover:border-primary hover:text-primary ${finalSpectroFile ? 'text-primary border-primary' : 'text-slate-500'}`}>
                                <FiPaperclip size={12} />
                                <span>
                                  {finalSpectroFile ? "Change" : "Attach"}
                                </span>
                                <input
                                  type="file"
                                  className="hidden"
                                  onChange={(e) => setFinalSpectroFile(e.target.files[0])}
                                />
                              </label>

                              {finalSpectroFile && (
                                <button
                                  type="button"
                                  onClick={() => setFinalSpectroFile(null)}
                                  className="w-8 h-8 flex items-center justify-center bg-red-50 text-red-500 rounded-none hover:bg-red-500 hover:text-white transition-all border border-red-100"
                                >
                                  <FiMinus size={14} />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>

                        {finalSpectroFile && (
                          <div className="mt-[-1rem] mb-6 mx-2 p-3 bg-green-50/50 border border-green-100 rounded-2xl flex items-center gap-3">
                            <div className="w-8 h-8 rounded-xl bg-green-100 flex items-center justify-center text-green-600">
                              <FiFileText size={16} />
                            </div>
                            <div className="flex-1 overflow-hidden">
                              <p className="text-[10px] font-bold text-green-700 uppercase tracking-widest opacity-60">Ready to Upload</p>
                              <p className="text-xs font-black text-green-800 truncate">{finalSpectroFile.name}</p>
                            </div>
                          </div>
                        )}

                        <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                          {finalSpectroInputs.map((item, index) => (
                            <div
                              key={index}
                              className="group relative transition-all mb-4"
                            >
                              <button
                                type="button"
                                onClick={() =>
                                  handleRemoveFinalSpectro(index)
                                }
                                className="absolute top-8 -right-2 w-7 h-7 bg-red-50 text-red-500 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10"
                              >
                                <FiMinus />
                              </button>
                              <div className="grid grid-cols-2 gap-4">
                                <InputField
                                  type="selectWithAdd"
                                  label="Component"
                                  value={item.componentId}
                                  onChange={(selected) => {
                                    const updated = [...finalSpectroInputs];
                                    updated[index].componentId =
                                      selected?.value;
                                    setFinalSpectroInputs(updated);
                                  }}
                                  options={isSpectroData}
                                  onAddNewClick={() =>
                                    setModalType("finalSpectroComponent")
                                  }
                                  placeholder="Select Component"
                                />
                                <InputField
                                  label="Value"
                                  type="text"
                                  value={item.percentage}
                                  onChange={(val) => {
                                    const updated = [...finalSpectroInputs];
                                    updated[index].percentage = val;
                                    setFinalSpectroInputs(updated);
                                  }}
                                  unit="%"
                                />
                              </div>
                            </div>
                          ))}
                        </div>

                        <button
                          type="button"
                          onClick={handleAddFinalSpectro}
                          className="w-full mt-6 py-4 bg-slate-50 text-slate-500 rounded-none text-xs font-black uppercase tracking-widest hover:bg-slate-100 transition-all duration-300"
                        >
                          + Add Final Component
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>

          <div className="p-4 bg-white border-t border-gray-200 flex items-center gap-4 shrink-0 sticky bottom-0 z-50 font-plus">
            <div className="flex-1 w-full max-w-md relative group">
              <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center justify-center text-slate-400">
                <FiFileText size={14} />
              </div>
              <input
                type="text"
                placeholder="Add production remarks..."
                className="w-full h-[38px] bg-slate-50 border border-slate-100 rounded-none pl-10 pr-4 text-[11px] font-semibold focus:bg-white focus:border-primary transition-all outline-none"
                value={foundryEntry.REMARK || ""}
                onChange={(e) =>
                  setFoundryEntry((prev) => ({
                    ...prev,
                    REMARK: e.target.value,
                  }))
                }
              />
            </div>

            <div className="flex items-center gap-4 ml-auto">
              <button
                type="button"
                onClick={onCancel}
                className="px-10 py-2 border border-gray-300 text-gray-500 font-black text-[10px] uppercase tracking-[2.5px] hover:bg-gray-50 hover:text-gray-700 transition-all disabled:opacity-50"
                disabled={isSaving}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleSubmit}
                disabled={isSaving}
                className="px-12 py-2 bg-primary text-white font-black text-[10px] uppercase tracking-[2.5px] hover:bg-primary/90 transition-all disabled:opacity-50"
              >
                {isSaving ? "Saving..." : (isEditing ? "Update" : "Save")}
              </button>
            </div>
          </div>
        </div>
      </div>


      <Model
        isOpen={!!modalType}
        onClose={() => setModalType(false)}
        name={`Add ${modalType}`}
      >
        <EntityAddModal
          type={modalType}
          onClose={(newOption) => {
            setModalType(null);
            handleEntityAddSuccess(modalType, newOption);
          }}
        />
      </Model>
    </div>
  );
};

export default FoundryForm;
